import { render } from "./PrintForShippment.vue?vue&type=template&id=80422c92&scoped=true"
import script from "./PrintForShippment.vue?vue&type=script&lang=js"
export * from "./PrintForShippment.vue?vue&type=script&lang=js"

import "./PrintForShippment.vue?vue&type=style&index=0&id=80422c92&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80422c92"]])

export default __exports__